import UserUtil from '../Util/UserUtil'
import JsUtils from '@/util/JsUtils'

export default {
  // https://dev.to/nkoik/writing-a-very-simple-plugin-in-vuejs---example-8g8
  // The install method will be called with the Vue constructor as the first argument, along with possible options
  install (Vue, options) {
    // Add $plugin instance method directly to Vue components
    Vue.prototype.$userIsInrol = (rol) => {
      return UserUtil.isInRol(rol)
    }

    Vue.prototype.$getConfigValue = (key, defValue = undefined) => {
      return UserUtil.getConfigValue(key, defValue)
    }

    /**
     * Convierte los atributos undetined a null en el obj origen.
     * Retorna una nueva instancia
     * @param obj
     */
    Vue.prototype.$undefinedToNull = (obj) => {
      let result = {...obj}
      for (let prop in result) {
        if (result.hasOwnProperty(prop)) {
          if (typeof result[prop] === 'undefined') {
            result[prop] = null
          }
        }
      }
      return result
    }

    /**
     * Extrae el mensaje de error desde una respuesta http de axios
     * @param error
     * @param defaultMessage - Mensaje por defecto
     */
    Vue.prototype.$getErrorMessage = (error, defaultMessage) => {
      if (error.response) {
        if (!JsUtils.isEmpty(error.response.data.errors)) {
          let result = ''
          for (let prop in error.response.data.errors) {
            if (error.response.data.errors.hasOwnProperty(prop)) {
              result += error.response.data.errors[prop] + '<br/>'
            }
          }
          return result
        }

        return JsUtils.isEmpty(error.response.data) ? defaultMessage : (JsUtils.isEmpty(error.response.data.message) ? defaultMessage : error.response.data.message)
      }
      return defaultMessage
    }

    Vue.prototype.$isEmpty = (val) => {
      return JsUtils.isEmpty(val)
    }
  }
}



// WEBPACK FOOTER //
// ./src/customization/GlobalBPOCore/plugins/GbpoGlobalPlugin.js